import { render, staticRenderFns } from "./DesignFeedbackPageContainer.vue?vue&type=template&id=7d46d9b0&"
import script from "./DesignFeedbackPageContainer.vue?vue&type=script&lang=js&"
export * from "./DesignFeedbackPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports